module.exports = __webpack_public_path__ + "static/maquete_4k-59f58a96096d223562193416665c4840.webp";